
import React from 'react';
import { FacilityOrderNewFlowUSIntakePatientNoteEditModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowUSIntakePatientNoteEditModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowUSIntakePatientNoteEditModalStore(rootStore, componentProps), 'facilityOrderNewFlowUSIntakePatientNoteEditModalStore')
@observer
class FacilityOrderNewFlowUSIntakePatientNoteEditModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowUSIntakePatientNoteEditModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowUSIntakePatientNoteEditModal;
